import { Button, CircularProgress, Backdrop, Box } from '@mui/material';
import COLORS from '../../resources/style/Themes';

/**
 * @typedef {object} LoadingDataProps
 * @prop {boolean} show - When true the spinner will show
 */

/**
 * Shows a page blocking spinner while awaiting response from API (i.e. after an PUt or POST call)
 * @param {LoadingDataProps} props
 */
const LoadingData = ({ show }) => {
  if (!show) return null;
  return (
    <Backdrop
      open={show}
      sx={{
        color: '#fff',
        zIndex: 99999,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
      }}
    >
      <Button
        sx={{
          borderRadius: '10px',
          height: '60px',
          width: '150px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: COLORS.SAFEGUARD_BLUE,
          cursor: 'default',
          color: COLORS.WHITE,
          padding: 0,
        }}
        disabled
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            height: '100%',
          }}
        >
          <CircularProgress size={36} sx={{ color: COLORS.WHITE }} />
        </Box>
      </Button>
    </Backdrop>
  );
};

export default LoadingData;
